/**
 * h5 首页模版
 */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import H5CommonComponent from '@tencent/h5-common-component';
import Toast from '../../../components/Toast';
import { PrivacyPopover } from '../../../components/PrivacyPopover';
import style from './index.module.scss';
import ChooseImageModal from '../../ChooseImageModal';
import { reportBtnClick } from '../../../utils/beacon';
const IndexPage = ({ playBtnUrl, isPrivacy, privacyCheckedImgUrl, privacyUnCheckedImgUrl, privacyPopoverImgUrl, bottomImgUrl, popoverHintImgUrl, privacyTitle, privacyContent, isVideo, isChooseImageModal, tipImage, onHandleChooseImage, actionBtnContent, isOriginPickerInWechat, bottomLogoUrl, children, }, ref) => {
    const [privacyCheckStatus, setPrivacyCheckStatus] = useState(true);
    const [toastVisible, setToastVisible] = useState(false);
    const [isShowChooseImageModal, setChooseImageModal] = useState(false);
    /**
     * 处理按钮点击
     */
    useImperativeHandle(ref, () => ({
        handleClickAction: handleClickAction,
    }));
    const handleClickAction = () => {
        // 如果没有选图弹窗活动，就直接选图
        if (!privacyCheckStatus) {
            return;
        }
        if (!isChooseImageModal) {
            const imagePickerInstance = new H5CommonComponent.ImagePickerEnhance(true, 0, isOriginPickerInWechat);
            imagePickerInstance.chooseImage((imgData, sourceType) => {
                if (typeof sourceType !== 'undefined') {
                    reportBtnClick(sourceType === 0 ? 'index#pick-album' : 'index#take-photo');
                }
                onHandleChooseImage(imgData);
            });
        }
        else {
            setChooseImageModal(true);
        }
    };
    return (React.createElement("div", { className: style['index-page'] },
        children,
        actionBtnContent ? (actionBtnContent) : (React.createElement("div", { className: style['action-panel'] },
            React.createElement("img", { "data-btn-id": "index#play-btn", className: style['play-btn'], src: playBtnUrl, onClick: handleClickAction }))),
        isPrivacy && !bottomLogoUrl ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: style['privacy-panel'] },
                React.createElement(PrivacyPopover, { checkedImgUrl: privacyCheckedImgUrl, unCheckedImgUrl: privacyUnCheckedImgUrl, isChecked: privacyCheckStatus, setCheckStatus: status => {
                        reportBtnClick(status ? 'check-privacy' : 'uncheck-privacy');
                        setPrivacyCheckStatus(status);
                    }, title: privacyTitle, content: privacyContent })),
            React.createElement("img", { src: bottomImgUrl, alt: "", className: style['bottom-img'] }),
            React.createElement(Toast, { msg: "\u8BF7\u5148\u52FE\u9009\u7528\u6237\u534F\u8BAE", visible: toastVisible, hideToast: () => {
                    setToastVisible(false);
                } }))) : (React.createElement(React.Fragment, null)),
        React.createElement(ChooseImageModal, { isShowMask: isShowChooseImageModal, tipImage: tipImage, onChooseImageInfo: onHandleChooseImage, onHandleCloseStatus: status => setChooseImageModal(status) }),
        bottomLogoUrl ? (React.createElement("div", { className: style.footer },
            React.createElement("div", { className: style.logo },
                React.createElement("img", { src: bottomLogoUrl, alt: "alt" })),
            isPrivacy ? (React.createElement("div", { className: style['bottom-privacy'] },
                React.createElement(PrivacyPopover, { theme: "simple", checkedImgUrl: privacyCheckedImgUrl, title: privacyTitle, content: privacyContent, isChecked: true, setCheckStatus: status => {
                        setPrivacyCheckStatus(status);
                    } }))) : null)) : null));
};
export default forwardRef(IndexPage);
